import { useCallback, useEffect, useState } from "react";
import { fetchLatestRegressionRun, fetchRegressionRunHistoryBar } from "../services/regressionRuns.service";
import { RegressionRun, RegressionRunSummary } from "./regression.types";

interface UseRegressionRunsResult {
  latest: RegressionRun | null;
  historyBar: RegressionRunSummary[];
  loading: boolean;
  error: boolean;
  refresh: () => void;
}

export function useRegressionRuns(): UseRegressionRunsResult {
  const [latest, setLatest] = useState<RegressionRun | null>(null);
  const [historyBar, setHistoryBar] = useState<RegressionRunSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);

    Promise.all([fetchLatestRegressionRun(), fetchRegressionRunHistoryBar(90)])
      .then(([latestRes, historyRes]: any[]) => {
        if (cancelled) return;
        setLatest(latestRes?.run ?? null);
        setHistoryBar(historyRes?.runs ?? []);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [reloadToken]);

  const refresh = useCallback(() => setReloadToken((t) => t + 1), []);

  return { latest, historyBar, loading, error, refresh };
}
